import { atom } from "recoil";

export const scheduleState = atom({
  key: "schedule",
  default: 0,
});
